import React from 'react';
import { MARQUEE_TERMS } from '../mock';

export default function Marquee() {
  const items = [...MARQUEE_TERMS, ...MARQUEE_TERMS];
  return (
    <section
      aria-hidden
      className="py-6 overflow-hidden border-y"
      style={{
        borderColor: 'rgba(15,27,20,0.08)',
        background: 'var(--bone-soft)',
      }}
    >
      <div className="marquee flex whitespace-nowrap">
        {items.map((t, i) => (
          <div key={i} className="flex items-center gap-10 px-6">
            <span
              className="display"
              style={{
                fontSize: 'clamp(1.5rem, 3.5vw, 2.75rem)',
                color: i % 2 === 0 ? 'var(--ink)' : 'var(--terracotta)',
                fontStyle: i % 3 === 0 ? 'italic' : 'normal',
                fontWeight: 400,
              }}
            >
              {t}
            </span>
            <span className="mono" style={{ color: 'var(--stone)' }}>•</span>
          </div>
        ))}
      </div>
    </section>
  );
}
